import { apiGet } from './client';
import type { AllStarsResponse } from './types';

export interface AllStarsFilters {
  serverId?: number;
  rankingPartitionId?: string;
  expansionId?: string;
  metric?: 'DAMAGE' | 'HEALING';
  snapshotDate?: string;
  limit?: number;
  page?: number;
  className?: string;
}

function queryString(filters: AllStarsFilters) {
  const params = new URLSearchParams();
  if (filters.serverId) params.set('serverId', String(filters.serverId));
  if (filters.rankingPartitionId) params.set('rankingPartitionId', filters.rankingPartitionId);
  if (filters.expansionId) params.set('expansionId', filters.expansionId);
  if (filters.metric) params.set('metric', filters.metric);
  if (filters.snapshotDate) params.set('snapshotDate', filters.snapshotDate);
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.page) params.set('page', String(filters.page));
  if (filters.className && filters.className !== 'all') params.set('className', filters.className);
  const text = params.toString();
  return text ? `?${text}` : '';
}

export async function fetchAllStars(filters: AllStarsFilters) {
  return apiGet<AllStarsResponse>(`/rankings/all-stars${queryString(filters)}`);
}

export async function fetchBossAllStars(bossId: string, filters: AllStarsFilters) {
  return apiGet<AllStarsResponse>(`/rankings/all-stars/boss/${encodeURIComponent(bossId)}${queryString(filters)}`);
}
